<template>
  <div class="h5-page">
    <div class="h5-header">
      <a-icon type="left" @click="() => $router.back()" />
      <span>订单详情</span>
      <span />
    </div>
    <div class="h5-body">
      <div class="h5-card">
        <div class="row">
          <span class="label">单据号</span><span>{{ detail.billNo }}</span>
        </div>
        <div class="row">
          <span class="label">伙伴</span><span>{{ detail.partnerName || '-' }}</span>
        </div>
        <div class="row">
          <span class="label">类型</span><span>{{ detail.subType }}</span>
        </div>
        <div class="row">
          <span class="label">金额</span><span>￥{{ formatAmount(detail.totalPrice) }}</span>
        </div>
        <div class="row">
          <span class="label">时间</span><span>{{ detail.operTime || '-' }}</span>
        </div>
        <div class="row">
          <span class="label">当前状态</span>
          <span class="cur-status">{{ detail.orderStatusName }}</span>
        </div>
        <div v-if="canPay" class="pay-area">
          <a-button type="primary" block :loading="paying" @click="handlePay">去支付</a-button>
          <div class="pay-tip">在线支付货款给供应商，支付后订单状态更新为已付款</div>
        </div>
      </div>
      <div class="h5-card">
        <div class="card-title">状态时间线</div>
        <div class="timeline">
          <div v-for="(node, index) in timelineNodes" :key="index" class="tl-node">
            <div class="tl-dot" :class="{ on: index === timelineNodes.length - 1 }" />
            <div class="tl-line" v-if="index < timelineNodes.length - 1" />
            <div class="tl-content">
              <div class="tl-head">
                <span class="tl-status">{{ node.statusName }}</span>
                <span class="tl-time">{{ node.time }}</span>
              </div>
              <div v-if="node.remark" class="tl-remark">{{ node.remark }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="h5-card">
        <div class="card-title">商品明细</div>
        <div class="item-row item-head">
          <span>商品</span><span>数量</span><span>单价</span><span>金额</span>
        </div>
        <div v-for="(item, index) in detail.items" :key="index" class="item-row">
          <span class="item-name">{{ item.materialName || '-' }}</span>
          <span>{{ item.operNumber }}{{ item.unit || '' }}</span>
          <span>{{ item.unitPrice }}</span>
          <span>{{ item.allPrice }}</span>
        </div>
        <div v-if="!detail.items || detail.items.length === 0" class="empty">暂无明细</div>
      </div>
    </div>
    <h5-tab-bar active="orders" />
  </div>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getH5OrderDetail, h5PayOrder } from '@/api/plugin/orderReceive'
import H5TabBar from './H5TabBar'
import './h5-common.css'

export default {
  name: 'H5OrderDetail',
  components: { H5TabBar },
  data() {
    return {
      detail: {},
      paying: false
    }
  },
  computed: {
    timelineNodes() {
      return this.detail.timeline || []
    },
    canPay() {
      const status = this.detail.orderStatus
      return !!status && String(status) < '80'
    }
  },
  created() {
    if (!Vue.ls.get(ACCESS_TOKEN)) {
      this.$router.replace('/h5/login')
      return
    }
    this.loadDetail()
  },
  methods: {
    loadDetail() {
      getH5OrderDetail(this.$route.params.headId).then(res => {
        if (res.success) {
          this.detail = res.data || {}
        } else if (res.code === 401) {
          this.$router.replace('/h5/login')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    /** 去支付：调统一下单取收银台链接并跳转，支付完成后回跳本页 */
    handlePay() {
      this.paying = true
      h5PayOrder(this.$route.params.headId, { returnUrl: window.location.href }).then(res => {
        if (res.success && res.data && res.data.payUrl) {
          window.location.href = res.data.payUrl
        } else if (res.code === 401) {
          this.$router.replace('/h5/login')
        } else {
          this.$message.warning(res.message || '支付下单失败')
          this.paying = false
        }
      }).catch(() => {
        this.paying = false
      })
    },
    formatAmount(value) {
      const num = Number(value)
      return isNaN(num) ? '0.00' : Math.abs(num).toFixed(2)
    }
  }
}
</script>
<style scoped>
.h5-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 14px;
}
.label {
  color: #888;
}
.cur-status {
  color: #1890ff;
  font-weight: 600;
}
.pay-area {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}
.pay-tip {
  color: #999;
  font-size: 12px;
  margin-top: 8px;
  text-align: center;
}
.card-title {
  font-weight: 600;
  margin-bottom: 10px;
}
.timeline {
  position: relative;
}
.tl-node {
  position: relative;
  padding: 0 0 18px 20px;
}
.tl-dot {
  position: absolute;
  left: 0;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #d9d9d9;
}
.tl-dot.on {
  background: #1890ff;
}
.tl-line {
  position: absolute;
  left: 4px;
  top: 16px;
  bottom: 0;
  width: 2px;
  background: #e8e8e8;
}
.tl-head {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.tl-status {
  font-weight: 600;
}
.tl-time {
  color: #999;
  font-size: 12px;
}
.tl-remark {
  color: #888;
  font-size: 12px;
  margin-top: 2px;
}
.item-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 13px;
}
.item-head {
  color: #888;
  border-bottom: 1px solid #f0f0f0;
}
.item-row span {
  flex: 1;
  text-align: right;
}
.item-row span:first-child {
  flex: 2;
  text-align: left;
}
.empty {
  text-align: center;
  color: #999;
  padding: 20px 0;
}
</style>
